import { render, staticRenderFns } from "./itProofSubmission.vue?vue&type=template&id=218e3d9d&scoped=true"
import script from "./itProofSubmission.vue?vue&type=script&lang=js"
export * from "./itProofSubmission.vue?vue&type=script&lang=js"
import style0 from "./itProofSubmission.vue?vue&type=style&index=0&id=218e3d9d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218e3d9d",
  null
  
)

export default component.exports